module.exports = "/static/assets/1e975e828fa86a4b68f0c362c22207f3.png";